module.exports = __webpack_public_path__ + "af119b260a6aa9f4359272de24715e6c.pdf";